<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'createTemplate',
})
</script>
<template>
    <a-modal :title="state.modalTitle" width="60%" :open="true" :confirmLoading="state.loading" :maskClosable="false"
        @ok="onFormSubmit" @cancel="
            () => {
                emit('cancel')
            }
        " :bodyStyle="{ maxHeight: '75vh', overflow: 'auto' }">
        <a-spin :spinning="state.loading">
            <a-form ref="ruleForm" :model="formState" v-bind="formLayout" :rules="rules">
                <a-form-item label="平台名称" name="name" required>
                    <a-input placeholder="请输入" v-model:value="formState.name"></a-input>
                </a-form-item>
                <a-form-item label="平台简称" name="platform_abbreviation" required>
                    <a-input placeholder="请输入" v-model:value="formState.platform_abbreviation"></a-input>
                </a-form-item>
                <a-form-item label="平台管理员手机号码">
                    <associate-authorization v-model:value="formState.super_admin_tels" placeholder="请输入平台管理员手机号码"
                        suffixTitle="回车或失去焦点后可以添加多个平台管理员手机号码" inputType="text"></associate-authorization>
                </a-form-item>
                <div class="form-tips-title">收款信息</div>
                <a-form-item label="子商户APPID" name="sub_appid">
                    <a-input placeholder="请输入" v-model:value="formState.sub_appid"></a-input>
                </a-form-item>
                <a-form-item label="子商户号" name="sub_mchid" required>
                    <a-input placeholder="请输入" v-model:value="formState.sub_mchid"></a-input>
                </a-form-item>
                <div class="form-tips-title">邮寄信息</div>
                <a-form-item label="地址省市区" name="send_area_ids">
                    <AddressCascader v-model:value="formState.send_area_ids" @change="
                        (res, e) => {
                            companyPauaChange(res, e, 'send_address')
                        }
                    "></AddressCascader>
                </a-form-item>
                <a-form-item label="详细地址" name="send_address">
                    <a-input placeholder="请输入公司注册地址" v-model:value="formState.send_address"> </a-input>
                </a-form-item>
                <a-form-item label="寄件人" name="send_name" required>
                    <a-input placeholder="请输入" v-model:value="formState.send_name"></a-input>
                </a-form-item>
                <a-form-item label="寄件人手机号" name="send_tel" :validate-status="checkdatastate.send_tel" required>
                    <a-input placeholder="请输入" v-model:value="formState.send_tel" @change="
                        (v) => {
                            phoneChange(v, 'send_tel')
                        }
                    "></a-input>
                </a-form-item>
                <div class="form-tips-title">包邮设置</div>
                <a-form-item label="是否包邮">
                    <a-switch checked-children="是" un-checked-children="否" :checkedValue="1" :unCheckedValue="2"
                        v-model:checked="formState.free_mail"></a-switch>
                </a-form-item>
                <a-form-item label="包邮时间" required v-if="formState.free_mail == 1">
                    <BetweenTimePick v-model:value="formState.free_between_time"></BetweenTimePick>
                </a-form-item>
                <a-form-item label="最小金额" required v-if="formState.free_mail == 1">
                    <a-input v-model:value="formState.free_zamount" style="width: 150px" prefix="￥" suffix="元">
                    </a-input>（章的金额）
                </a-form-item>
                <a-form-item label="最小枚数" required v-if="formState.free_mail == 1">
                    <a-input v-model:value="formState.free_znum" style="width: 150px" suffix="枚">
                    </a-input>
                </a-form-item>
                <a-form-item label="最大减免邮费" required v-if="formState.free_mail == 1">
                    <a-input v-model:value="formState.free_money" style="width: 150px" prefix="￥" suffix="元">
                    </a-input>（超过此则补差价）
                </a-form-item>

                <div class="form-tips-title">相关模板</div>
                <a-form-item label="备案表模板" name="beian_url">
                    <a-input placeholder="请输入" v-model:value="formState.beian_url"></a-input>
                </a-form-item>
                <a-form-item label="遗失申明模板" name="lost_url">
                    <a-input placeholder="请输入" v-model:value="formState.lost_url"></a-input>
                </a-form-item>
            </a-form>
        </a-spin>
    </a-modal>
</template>

<script lang="ts" setup name="createTemplate">
import { reactive, ref, onMounted, computed } from 'vue'
import { message } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import { AddressCascader, AssociateAuthorization } from '@/components'
import BetweenTimePick from '@/components/base/BetweenTimePick.vue'
const props = defineProps({
    detailData: {
        type: Object,
        default: () => null
    }
})
const emit = defineEmits(['cancel', 'ok'])
const ruleForm = ref()
const rules = {
    send_area_ids: [{ required: true, message: '请选择公司地址省市区' }],
}
const formLayout = {
    labelCol: {
        xs: { span: 7 },
        sm: { span: 7 }
    },
    wrapperCol: {
        xs: { span: 10 },
        sm: { span: 10 }
    }
}
interface state {
    modalTitle: string
    loading: boolean
    isEdit: boolean
}
const state = reactive<state>({
    modalTitle: '新增刻章平台',
    loading: false,
    isEdit: false,
})
const checkdatastate = reactive<any>({})
interface formState {
    name: string
    platform_abbreviation: string
    sub_appid: string
    sub_mchid: string
    send_area_ids: string
    send_address: string
    send_name: string
    send_tel: string
    beian_url: string
    lost_url: string
    super_admin_tels: string

    free_mail: number
    free_between_time: string
    free_znum: number
    free_zamount: number
    free_money: number

}
let formState = reactive<formState>({
    name: '',
    platform_abbreviation: '',
    sub_appid: '',
    sub_mchid: '',
    send_area_ids: '',
    send_address: '',
    send_name: '',
    send_tel: '',
    beian_url: '',
    lost_url: '',
    super_admin_tels: '',
    free_mail: 2,
    free_between_time: '',
    free_znum: 0,
    free_zamount: 0,
    free_money: 0

})
onMounted(() => {
    if (props.detailData?.id) {
        state.modalTitle = '编辑【' + props.detailData.name + '】平台'
        state.isEdit = true
        queryDetail(props.detailData?.id)
    }
})
const queryDetail = (id) => {
    state.loading = true
    let requeryParam = {
        url: `/admin/v1/kezhang_platform/${id}/edit`,
        method: 'get'
    }
    baseService(requeryParam)
        .then((res) => {
            Object.assign(formState, res.data)
        })
        .finally(() => {
            state.loading = false
        })
}
// 省市区 选择和替换
const companyPauaChange = (res, e, type) => {
    let address = `${e[0].name}${e[1].name}${e[2].name}`
    formState[type] = address
}
const phoneChange = (v, type) => {
    let str = v.target.value.replaceAll(/\D/g, '')
    formState[type] = str
    //判断str是不是手机号码
    if (!/^1[23456789]\d{9}$/.test(str)) {
        checkdatastate[type] = 'error'
    } else {
        checkdatastate[type] = 'success'
        formState[type] = str
    }
}
const onFormSubmit = () => {
    ruleForm.value
        .validate()
        .then(() => {
            state.loading = true
            if (props.detailData?.id > 0) {
                let requeryParam = {
                    url: '/admin/v1/kezhang_platform/' + props.detailData.id,
                    method: 'put',
                    data: formState
                }
                baseService(requeryParam)
                    .then((res: any) => {
                        state.loading = false
                        message.success(res.msg)
                        emit('ok')
                    })
                    .catch((res) => {
                        state.loading = false
                        if (res.msg) {
                            message.error(res.msg)
                        } else {
                            message.error('操作失败')
                        }
                    })
            } else {
                let requeryParam = {
                    url: '/admin/v1/kezhang_platform',
                    method: 'post',
                    data: formState
                }
                baseService(requeryParam)
                    .then((res: any) => {
                        state.loading = false
                        message.success(res.msg)
                        emit('ok')
                    })
                    .catch((res) => {
                        state.loading = false
                        if (res.msg) {
                            message.error(res.msg)
                        } else {
                            message.error('操作失败')
                        }
                    })
            }
        })
        .catch(() => { })
}
</script>

<style lang="less" scoped></style>
